// apps/web/src/components/ui/empty-state.tsx
//
// Phase 8 in-repo custom primitive — the shadcn registry's `empty` block is
// overkill for v1 (carries placeholder illustrations + dual CTAs). This is a
// 30-line file: centered icon + heading + body + single CTA. Mirrors the
// Phase 6 pill.tsx pattern (in-repo custom). Used by Author UI form section
// empty states + PreviewPane "Add a widget to see a live preview." state.
//
// Visual contract: UI-SPEC §"EmptyState component spec" (lines 495-520).
import type { LucideIcon } from "lucide-react";
import type * as React from "react";
import { Button } from "./button.js";

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  body?: string;
  cta?: { label: string; onClick: () => void };
}

export function EmptyState({ icon: Icon, title, body, cta }: EmptyStateProps): React.ReactElement {
  return (
    <div className="flex flex-col items-center gap-2 rounded-md border border-dashed border-input p-6 text-center">
      {Icon ? <Icon className="size-6 text-muted-foreground" aria-hidden /> : null}
      <p className="text-sm font-semibold text-foreground">{title}</p>
      {body ? <p className="text-xs text-muted-foreground">{body}</p> : null}
      {cta ? (
        <Button variant="outline" size="sm" onClick={cta.onClick}>
          {cta.label}
        </Button>
      ) : null}
    </div>
  );
}
EmptyState.displayName = "EmptyState";
